var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('div',{attrs:{"id":"map"}}),_c('v-btn',{attrs:{"small":"","tile":"","color":"white text-capitalize font-weight-bold"},on:{"click":_vm.zoomToFit}},[_vm._v("zoom to fit")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }